module.exports = __webpack_public_path__ + "static/img/develop-banner2.cdf8dcf1.png";